/*jshint esversion: 6 */

import axios from 'axios';
const base = '/wp-json/wp/v2/';
const customBase = '/wp-json/abbapi/';

const get = (entryPoint) => {
    return axios.get(entryPoint);
};

export const getQuiz = (Id) => {
    return get(base + 'quiz/' + Id);
};

export const getQuestion = (Id) => {
    return get(base + 'question/' + Id);
};

export const getTime = () => {

    return get(customBase + 'time/');
}




